import Swiper from 'swiper'
//import Swiper from 'swiper/bundle'
import { Autoplay, Pagination, Thumbs, Navigation } from 'swiper/modules'

document.addEventListener('DOMContentLoaded', () => {
  const swiperHeader = new Swiper('.swiperHeader', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    speed: 2000,
    allowTouchMove: false,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      dynamicBullets: true,
      clickable: true,
    },
    modules: [Pagination, Autoplay],
  })

  const swiperBasicConfig = {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 3000,
    },
    speed: 800,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
    pagination: {
      el: '.swiper-pagination-breakfast',
      clickable: true,
    },
    modules: [Navigation, Autoplay, Pagination],
  }

  const swiperBasicSliders = document.querySelectorAll('.swiperBasic')
  swiperBasicSliders.forEach((element, index) => {
    new Swiper(element, {
      ...swiperBasicConfig,
      navigation: {
        nextEl: `.swiper-button-next-basic-${index}`,
        prevEl: `.swiper-button-prev-basic-${index}`,
      },
    })
  })

  const swiperRoomsConfig = {
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
    spaceBetween: 20,
    autoplay: {
      delay: 3000,
    },
    speed: 800,
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 32,
      },
      1280: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 48,
      },
    },
    modules: [Navigation, Pagination],
  }

  const swiperRoomsSliders = document.querySelectorAll('.swiperRooms')
  swiperRoomsSliders.forEach((element, index) => {
    new Swiper(element, {
      ...swiperRoomsConfig,
      navigation: {
        nextEl: `.swiper-button-next-rooms-${index}`,
        prevEl: `.swiper-button-prev-rooms-${index}`,
      },
      pagination: {
        el: '.swiper-pagination-rooms',
        clickable: true,
      },
    })
  })

  const swiperSingleRoomThumbs = new Swiper('.swiperSingleRoomThumbs', {
    //loop: true,
    spaceBetween: 12,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      640: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 5,
      },
    },
    modules: [Thumbs],
  })

  const swiperSingleRoomMain = new Swiper('.swiperSingleRoomMain', {
    //loop: true,
    spaceBetween: 5,
    navigation: {
      nextEl: '.swiper-button-next-single-room',
      prevEl: '.swiper-button-prev-single-room',
    },
    thumbs: {
      swiper: swiperSingleRoomThumbs,
    },
    breakpoints: {
      1024: {
        spaceBetween: 5,
      },
    },
    modules: [Navigation, Thumbs],
  })
})
